import { Navigate } from 'react-router-dom';
import { dtpPath, useDtpParams } from '../../lib/clinicSite';

/** Legacy membership bookmarks share the full membership management screen. */
export default function DtpPortal() {
  const { physicianId } = useDtpParams();
  return <Navigate to={dtpPath(physicianId, '/membership')} replace />;
}
